import EditorOverlay from './EditorOverlay';
export default EditorOverlay;
//# sourceMappingURL=index.js.mapimport EditorOverlay from './EditorOverlay';
export default EditorOverlay;
//# sourceMappingURL=index.js.map